// src/components/ServiceCategorySelect.tsx
import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";
import type { SelectChangeEvent } from "@mui/material/Select";
import { ServiceCategory } from "../api/serviceCategories";

type Props = {
  label?: string;
  categories: ServiceCategory[];
  value: string | null;
  onChange: (value: string | null) => void;
  disabled?: boolean;
  errorText?: string;
  includeNoneOption?: boolean; // show "No category"
};

const ServiceCategorySelect: React.FC<Props> = ({
  label = "Category",
  categories,
  value,
  onChange,
  disabled,
  errorText,
  includeNoneOption = true,
}) => {
  const handleChange = (event: SelectChangeEvent) => {
    const val = event.target.value as string;
    onChange(val || null);
  };

  return (
    <FormControl fullWidth size="small" disabled={disabled} error={!!errorText}>
      <InputLabel>{label}</InputLabel>
      <Select
        label={label}
        value={value || ""}
        onChange={handleChange}
      >
        {includeNoneOption && (
          <MenuItem value="">
            <em>No category</em>
          </MenuItem>
        )}
        {categories.map((cat) => (
          <MenuItem
            key={cat.service_category_id}
            value={cat.service_category_id}
          >
            {cat.name}
          </MenuItem>
        ))}
      </Select>
      {errorText && <FormHelperText>{errorText}</FormHelperText>}
    </FormControl>
  );
};

export default ServiceCategorySelect;
